<template>
    <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 120px;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">FRANKA ROBOTICS, 创新与人才相遇的地方</span>
        <h1>Franka和团队共同成长</h1> 
        <span class="c-mt-10 c-mb-10 c-text-left ">
          无论您是工程师还是设计师，经理还是开发人员，都可以成为这群人才中的一员-我们将进一步丰富我们多样化的背景和专业知识，并继续共同成长。
        </span> 
      </div>
  
      <div class="display-width">
        <img src="@/assets/images/webinars/image (3).png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
      
 
  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1029px) {
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: calc(100% - 40px);
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
  